import React from 'react';
import {
  Card,
  Checkbox,
  Stack,
  Text,
  TextInput,
  UnstyledButton,
  Select,
} from '@mantine/core';
import { useEmployeeFormContext } from '../EmployeeEducationSection';
import { type EmployeeLanguages } from '@/schemas/API/GET/employee/response';
import { IconPlus } from '@tabler/icons-react';
import { TbTrashXFilled } from 'react-icons/tb';
import { getFetcher } from '@/api/fetchers';
import useSWR from 'swr';

const EmployeeBasicEducationCard: React.FC = () => {
  const form = useEmployeeFormContext();

  const handleCreateLang = (): void => {
    const newLanguage = {
      id: 0,
      level: '',
    };
    form.insertListItem('langs', newLanguage);
  };

  const handleDeleteLang = (index: number): void => {
    form.removeListItem('langs', index);
  };

  const { data: languages } = useSWR<EmployeeLanguages[]>(
    '/employees/languages',
    getFetcher
  );

  const langOptions =
    languages?.map(lang => ({
      value: String(lang.id),
      label: lang.name ?? '',
    })) ?? [];

  const langRows = form.values.langs?.map((lang: any, index: number) => (
    <tr key={index}>
      <td style={{ width: '75%' }} className="pr-3 pt-3">
        <Select
          variant="filled"
          radius="md"
          placeholder="Select language"
          data={langOptions}
          value={String(lang.id)}
          onChange={value =>
            form.setFieldValue(`langs.${index}.id`, Number(value))
          }
        />
      </td>
      <td className="pr-3 pt-3">
        <TextInput
          variant="filled"
          radius="md"
          placeholder="znalost"
          {...form.getInputProps(`langs.${index}.level`)}
        />
      </td>
      <td className="pt-3">
        <UnstyledButton
          data-testid="delete lang"
          onClick={() => handleDeleteLang(index)}
        >
          <TbTrashXFilled size="30" />
        </UnstyledButton>
      </td>
    </tr>
  ));

  return (
    <Card padding="md" radius="md" withBorder className="h-full">
      <Text fw={700} size="large">
        Vzdělání
      </Text>

      <Stack gap="sm" className="mt-3">
        <TextInput
          variant="filled"
          radius="md"
          placeholder="typ"
          label="Typ"
          {...form.getInputProps(`eduType`)}
        />
        <Checkbox
          labelPosition="left"
          label="Může poskytnout první pomoc"
          checked={form.getInputProps('canFirstAid').value}
          onChange={form.getInputProps('canFirstAid').onChange}
        />
        <table>
          <thead>
            <tr>
              <th className="text-left">Jazyk</th>
              <th className="text-left">Znalost</th>
              <th>
                <UnstyledButton
                  data-testid="add lang"
                  onClick={handleCreateLang}
                >
                  <IconPlus />
                </UnstyledButton>
              </th>
            </tr>
          </thead>
          <tbody>{langRows}</tbody>
        </table>
      </Stack>
    </Card>
  );
};

export default EmployeeBasicEducationCard;
